import React from "react";
import {observer} from "mobx-react-lite";
import appStore from "../../storage/AppStore";
import {Link} from "react-router-dom";

const AdminMenu = () => {
    if (!appStore.user.is_admin) return null
    return (
        <li className="nav-item dropdown position-static py-lg-2 me-lg-n1 me-xl-0">
            <a className="nav-link dropdown-toggle active" aria-current="page" href="#" role="button"
               data-bs-toggle="dropdown" data-bs-trigger="hover" aria-expanded="false">Админ</a>

            <div className="dropdown-menu rounded-4 p-4"
                 style={{"--cz-dropdown-spacer": ".875rem", "maxWidth": "600px", "overflowX": "auto"}}>
                <div className="d-flex flex-column flex-lg-row gap-4">
                    <div style={{"minWidth": "190px"}}>
                        <div className="h6 mb-2"><Link to="/admin/companies" >Компаниялар</Link></div>
                        <ul className="nav flex-column gap-2 mt-0">
                            <li className="d-flex w-100 pt-1">
                                <Link
                                    className="nav-link animate-underline animate-target d-inline fw-normal text-truncate p-0"
                                    to="/admin/new_company">Жаңы компания</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </li>
    )
}
export default observer(AdminMenu)

// <Link to={"/admin/companies"}>{appStore.t('companies')}</Link>
{/*<li className="nav-item dropdown position-static py-lg-2 me-lg-n1 me-xl-0">*/}
            {/*  <a className="nav-link dropdown-toggle active" aria-current="page" href="#" role="button"*/}
            {/*     data-bs-toggle="dropdown" data-bs-trigger="hover" aria-expanded="false">{appStore.user.locationPath}</a>*/}

            {/*  <div className="dropdown-menu rounded-4 p-4"*/}
            {/*       style={{"--cz-dropdown-spacer": ".875rem", "maxWidth": "600px", "overflowX": "auto"}}>*/}
            {/*    <div className="d-flex flex-column flex-lg-row gap-4">*/}
            {/*      <div style={{"minWidth": "190px"}}>*/}
            {/*        <div className="h6 mb-2"><a href="" onClick={(e)=>{e.preventDefault(); appStore.user.setCountry(12); marketStore.getProducts()}}>{appStore.tr.whole_country}</a></div>*/}
            {/*        <div className="h6 mb-2"><a href="" onClick={(e)=>{e.preventDefault(); appStore.user.setDistrict(12, 209, 103184); marketStore.getProducts()}}>Бишкек</a></div>*/}
            {/*        <div className="h6 mt-2 mb-2"><a href="" onClick={(e)=>{e.preventDefault(); appStore.user.setDistrict(12, 214, 103218); marketStore.getProducts()}}>Ош</a></div>*/}
            {/*      </div>*/}
            {/*      {appStore.user.regionTree.map((region, index1) => (*/}
            {/*          <div key={index1} style={{"minWidth": "190px"}}>*/}
            {/*            <div className="h6 mb-2"><a href="" onClick={(e)=>{e.preventDefault(); appStore.user.setRegion(12, region.id); marketStore.getProducts()}}>{region[appStore.user.language] || region.name}</a></div>*/}
            {/*            {region.districts.length > 0 && (*/}
            {/*                <ul className="nav flex-row gap-2 mt-0" style={{"maxHeight": "200px", "overflowY": "auto"}}>*/}
            {/*                  {region.districts.map((district, index2) => (*/}
            {/*                    <li key={index2} className="d-flex w-100 pt-1">*/}
            {/*                      <a*/}
            {/*                          href=""*/}
            {/*                          onClick={(e)=>{e.preventDefault(); appStore.user.setDistrict(12, region.id, district.id); marketStore.getProducts()}}*/}
            {/*                          className="nav-link animate-underline animate-target d-inline fw-normal text-truncate p-0"*/}
            {/*                        >{district[appStore.user.language] || district.name}</a>*/}
            {/*                    </li>*/}
            {/*                  ))}*/}
            {/*                </ul>*/}
            {/*            )}*/}
            {/*          </div>*/}
            {/*      ))}*/}
            {/*    </div>*/}
            {/*  </div>*/}
            {/*</li>*/}